import { render, staticRenderFns } from "./CatalogItemsList.vue?vue&type=template&id=0fadcd74&"
import script from "./CatalogItemsList.vue?vue&type=script&lang=js&"
export * from "./CatalogItemsList.vue?vue&type=script&lang=js&"
import style0 from "./CatalogItemsList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/vagrant/interfaces/online/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VIcon,VLayout,VSelect})
